export default __webpack_public_path__ + "dc1f011f5ef8d792917421b62d7b1c43.png";